<template>
  <app-main @close-about="$emit('close-about')" :showAbout="showAbout" @open-signup="$emit('open-signup')"></app-main>
</template>

<script>
import AppMain from "../components/main";
export default {
  name: "AppView",
  components: { AppMain },
  props: {
    showAbout: Boolean
  }
};
</script>

<style scoped>
.home-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
}
</style>
